<template>
    <div class="sys_msg">
        <div class="sys_msg_main">
            <div class="sys_msg_container">
                <div class="title font-bold">{{$t('personalCenter.systemNotices')}}</div>
                <template v-if="noticeList?.length">
                    <div class="notice-list">
                        <div v-for="(item,index) in noticeList" :key="index" class="notice-item flexlayout">
                            <div @click="toDetail(item.id)"
                                class="des_one_row font_size_mini" style="margin-right: 25px;max-width: 1000px; color: #666;">
                                {{ item.title }}
                            </div>
                            <div style="font-size: 12px; color: #999;">{{ handledate1(item.updateTime) }}</div>
                        </div>
                    </div>

                    <div class="divider"></div>

                    <div class="paging-layout">
                        <span style="margin-right: 15px;font-size: 12px;color: #666;line-height: 24px;">{{$t('personalCenter.totalPage')}}{{ pageTotal }} {{$t('personalCenter.page')}} <span v-if="locale === 'en'">{{'&nbsp;'}}</span>
                            {{$t('personalCenter.currentPage')}}{{ currentPage }}/{{ pageTotal }} {{$t('personalCenter.page')}}</span>
                        <span><el-pagination @current-change="changeSize" :current-page="currentPage" small background
                                layout="prev, pager, next" :default-page-size="offset" :total="total" /></span>
                        <span style="font-size: 12px;color: #666;margin-left: 35px;">{{$t('personalCenter.toPage')}}<input type='number'
                                v-model="currentPage" @input="toPage"
                                style="text-align: center; caret-color: #666; width: 24px; height: 24px; color: #666; font-weight: 500; outline: none;border: 1px solid #E6e6e6;margin: 0px 5px;">
                            {{$t('personalCenter.page')}}</span>
                    </div>
                </template>
                <div v-else>
                    <el-empty :image="require('@/assets/image/empty@3x.png')" :image-size="220" description="$t('personalCenter.noTips'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ref, onBeforeMount, computed } from 'vue'
import { getSysNoticeList } from '@/api/control'
import { handledate1 } from '@/utils/common'
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

let total = ref(0)
const offset = ref(15)
const currentPage = ref(1)
const noticeList = ref([])
const router = useRouter()
onBeforeMount(() => {
    getMessage()
})
const pageTotal = computed(() => {
    return Math.ceil(total.value / offset.value);
});

//前往第几页 
const toPage = () => {
    getMessage(currentPage.value)
}
//分页按钮改变
const changeSize = (value) => {
    currentPage.value = value
    getMessage()
}
//获取用户通知分页列表
const getMessage = () => {
    getSysNoticeList({ 
        limit: currentPage.value, 
        offset: offset.value
     }).then(res => {
        total.value = res.result.count
        noticeList.value = res.result.data
    }).catch(err => { console.log(err); })
}

const toDetail = (id) => {
    router.push({ 
        path: '/home/controldetail', 
        query: { type: 'sysmessage', id } 
    })
}
</script>

<style lang="scss" scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

@media (min-width: 1200px) {
    .sys_msg_container {
        width: 1105px;
    }
}

@media (max-width: 1200px) {
    .sys_msg_container {
        width: calc(100vw - 80px);
    }
}

.divider {
    position: relative;
    height: 1px;
    margin-bottom: 32px;
}

.divider:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0px;
    right: 0;
    height: 0.5px;
    background-color: rgba(0, 0, 0, 0.1);
}

.paging-layout {
    display: flex;
    justify-content: end;
    margin-right: 24px;
}

.sys_msg {
    background-color: #f8f8f8;
    min-height: calc(100vh - 56px);
    .sys_msg_main {
        padding: 24px 0 32px;
    }
    .sys_msg_container {
        height: 960px;
        padding-top: 24px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 4px;

        ::v-deep li.is-active.number {
            background-color: #386AEA;  
        }

        ::v-deep .el-pager li:not(.is-active):hover {
            color: #386AEA;
        }

        ::v-deep .el-pager li,
        .btn-prev,
        ::v-deep button.btn-prev.is-first,
        ::v-deep button.btn-next.is-last {
            margin: 0px;
            box-shadow: 0 0 0 0.5px #e6e6e6;
            border-radius: 0px;
        }

        .font_size_mini {
            font-size: 14px;
            font-weight: 400;
        }

        .notice-list {
            height: 784px;
            .notice-item {
                margin-bottom: 32px;
                padding: 0 24px;
                cursor: pointer;
            }
            > :last-child {
                margin-bottom: 20px
            }
        }
        

        .flexlayout {
            display: flex;
            justify-content: space-between;
            flex-wrap: nowrap;
        }

        .des_one_row {
            overflow: hidden;
            text-overflow: ellipsis;
            text-overflow: -webkit-ellipsis-lastline;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
        }

        .title {
            color: #333;
            font-size: 24px;
            line-height: 36px;
            padding-left: 24px;
            margin-bottom: 26px;
        }
    }
}
</style>